import React, { useState, useEffect } from "react";
import styles from "./CreateUser.module.scss";
import { Container, Row, Col, Card, Button, Form, Nav, Tab, Modal, InputGroup } from "react-bootstrap";
import UserForm from "./UserForm";
import { t } from "i18next";
import UserTabs from "./UserTabs";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import PermissionsTabContent from "./PermissionsTabContent";
import ReportPreferenceTabContent from "./ReportPreference"
import SecurityTabContent from "./SecurityTabContent";
import Functions from "../../../General/Functions";
import { Toast, ToastContainer } from "react-bootstrap";
import DataManager from "../../../General/DataManager";
import UserClass from "../../../General/LocalStorage/UserClass";
import { parsePhoneNumberFromString } from 'libphonenumber-js';



const EditUser = () => {

    const { state } = useLocation();
    const { id } = useParams();
    const navigate = useNavigate();
    // Fallback safety (page refresh, direct access)
    //const user = state?.user;
    const [user, setUser] = useState(state?.user ?? null);
    //const ports = state?.ports || [];
    //const assignedPortIds = state?.assignedPortIds || [];

    useEffect(() => {
        if (!user) return;

        const parsed =
            typeof user.phoneNumber === "string"
                ? parsePhoneNumberFromString(user.phoneNumber)
                : null;

        const countryCode = parsed ? `+${parsed.countryCallingCode}` : "";
        const numberWithoutCountry = parsed ? parsed.nationalNumber : "";

        setForm({
            firstName: user.firstName,
            lastName: user.lastName,
            username: user.email,
            email: user.email,
            companies: user.companies ?? [],
            phoneNumber: numberWithoutCountry,
            phoneCountryCode: countryCode,
            ports: user.ports ?? [],
            reportTypes: user.reports ?? [],
            role: user.role,
            status: user.status,
        });

        setSelectedPorts(user.ports ?? []);
        setSelectedReportTypes(user.reports ?? []);

    }, [user]);

    useEffect(() => {
        if (user) return;

        const fetchUser = async () => {
            try {
                let instance = UserClass.getInstance();
                let token = instance.getTokenUser();
                const { data, msgError } = await DataManager.getUser(token, id);

                console.log("data", data)

                if (msgError) {
                    console.error(msgError);
                    return;
                }
                setUser(data)
            } catch (err) {
                console.error("Failed to fetch user", err);
            }
        };

        fetchUser();
    }, [id, user]);


    useEffect(() => {
        if (!user) return;
        getCompanies();
        getReportTypes();
        getRoles();
        if (user?.role === "BOARDING_OPERATOR" && Array.isArray(user.companies) && typeof user.companies[0] === "string") {
            getPorts(user?.companies[0]);
        }
    }, [user]);

    if (!user) {
        // Optional: refetch user by ID if state is missing
        console.warn("No navigation state, fetch user by ID:", id);
    }

    //const parsed = user?.phoneNumber ? parsePhoneNumberFromString(user?.phoneNumber) : null;
    const parsed = typeof user?.phoneNumber === "string" ? parsePhoneNumberFromString(user.phoneNumber) : null;

    let countryCode = "";
    let numberWithoutCountry = "";

    if (parsed) {
        countryCode = `+${parsed.countryCallingCode}`;
        numberWithoutCountry = parsed.nationalNumber;
    } else {
        console.log('Invalid phone number');
    }
    const [form, setForm] = useState({
        firstName: user?.firstName,
        lastName: user?.lastName,
        username: user?.email,
        email: user?.email,
        companies: user?.companies,
        phoneNumber: numberWithoutCountry,
        phoneCountryCode: countryCode,
        ports: user?.ports,
        reportTypes: user?.reports,
        role: user?.role,
        status: user?.status,

    });


    const [showPassword, setShowPassword] = useState(false);
    const [showModalCancel, setShowModalCancel] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const [activeTab, setActiveTab] = useState("profile");
    const [showModal, setShowModal] = useState(false);
    const [saveProgress, setSaveProgress] = useState(0);
    const [updateError, setUpdateError] = useState(null);
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [copied, setCopied] = useState(false);
    const [showConfirmReset, setShowConfirmReset] = useState(false);
    const [companies, setCompanies] = useState([])
    const [ports, setPorts] = useState([]);
    const [portsError, setPortsError] = useState(null);
    const [isLoadingPorts, setIsLoadingPorts] = useState(false);
    const [selectedPorts, setSelectedPorts] = useState(user?.ports ?? []);
    const [roles, setRoles] = useState([]);
    const [isLoadingRoles, setIsLoadingRoles] = useState(false);
    const [rolesError, setRolesError] = useState(null);

    //handle reports

    const [isLoadingReportTypes, setIsLoadingReportTypes] = useState(false);
    const [reportTypesError, setReportTypesError] = useState(null);
    const [reportTypes, setReportTypes] = useState([]);
    const [selectedReportTypes, setSelectedReportTypes] = useState([]);




    const handleChange = (e) => {

        const { name, value } = e.target;

        let finalValue = value;

        if (name === "defaultReportRecipient") {
            finalValue = e.target.checked;
        }

        if (name === "companies") {

            finalValue = value ? value?.map(v => v.value) : [];

            if (form.role === "BOARDING_OPERATOR" && finalValue.length > 1) {
                setErrors(prev => ({
                    ...prev,
                    companies: t('error_boarding_operator_one_company')
                }));
                return;
            }
        }

        if (name === "role") {
            if (
                value === "BOARDING_OPERATOR" &&
                form.companies.length > 1
            ) {


                setErrors(prev => ({
                    ...prev,
                    companies: t('error_boarding_operator_one_company')
                }));
                return;

            }

            if (form.companies.length === 1) {
                setPorts([]);
                setSelectedPorts([]);
                getPorts(form.companies[0]);
            }
        }

        setForm(prev => ({
            ...prev,
            ...(name === "email" ? { email: finalValue, username: finalValue } : { [name]: finalValue })
        }));

        if (name === "companies" || name === "role") {

            if ((finalValue && finalValue.length > 0) || finalValue !== "") {

                setErrors(prev => {
                    const newErrors = { ...prev };

                    if ("companies" in newErrors) {
                        delete newErrors["companies"];
                    }

                    return newErrors;
                });
            }
        }
        else {
            if (typeof finalValue === "string" && finalValue?.trim() !== "") {
                setErrors(prev => {
                    const newErrors = { ...prev };

                    if (name in newErrors) {
                        delete newErrors[name];
                    }

                    return newErrors;
                });
            }
        }
        if (name === "companies") {
            setPorts([]);
            setSelectedPorts([]);
            if (finalValue?.length === 1) {
                getPorts(finalValue[0]);
            }
        }

    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(form)
        const isEdit = true;
        const validationErrors = Functions.validateUserForm(form, selectedPorts, isEdit);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        setShowModal(true);
        handleConfirm();

    };

    const getCompanies = () => {
        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();

        DataManager.verifyLogin
            (token).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['verifylogin']) !== 'undefined' && result['verifylogin'] !== null) {

                        setCompanies(result['verifylogin']['companies'])
                    } else {
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            });
    }

    const getPorts = async (company) => {
        setIsLoadingPorts(true);
        setPortsError(null);

        try {
            const instance = UserClass.getInstance();
            const token = instance.getTokenUser();

            const { ports, msgError } = await DataManager.getPorts(company, token);


            if (msgError) {
                throw new Error(msgError);
            }

            setPorts(ports["results"] ?? []);
        } catch (error) {
            setPorts([]);
            setPortsError(error.message || t("msgErrorGeneral"));
        } finally {
            setIsLoadingPorts(false);
        }
    };

    const getReportTypes = async () => {

        setIsLoadingReportTypes(true);
        setReportTypesError(null);

        try {
            const instance = UserClass.getInstance();
            const token = instance.getTokenUser();

            const { data, msgError } = await DataManager.getReportTypes(token);


            if (msgError) {
                throw new Error(msgError);
            }

            setReportTypes(data);
        } catch (error) {
            setReportTypes([]);
            setReportTypesError(error.message || t("msgErrorGeneral"));
        } finally {
            setIsLoadingReportTypes(false);
        }

    }


    const handleCancelUpdate = () => {

        window.location.href = "/pages/UserManagement/Details/" + id;
    }


    const togglePort = (portId) => {

        setSelectedPorts((prev) => {
            const updatedPorts = prev?.includes(portId)
                ? prev?.filter((id) => id !== portId)
                : [...prev, portId];

            // Clear ports error if at least one port is selected
            if (updatedPorts.length > 0) {
                setErrors((prevErrors) => {
                    if (!prevErrors.ports) return prevErrors;

                    const newErrors = { ...prevErrors };
                    delete newErrors.ports;
                    return newErrors;
                });
            }

            return updatedPorts;
        });
    };

    const toggleReportType = (id) => {

        setSelectedReportTypes((prev) => {
            const exists = prev.find(r => r.id === id);

            if (exists) {
                // removing report
                return prev.filter(r => r.id !== id);
            }

            // adding report
            return [
                ...prev,
                { id: id, defaultSending: false, appearInSendingList: false }
            ];
        });
    };


    const handleConfirm = async () => {
        setIsSaving(true);
        setSaveProgress(20);
        setUpdateError(null);



        const normalizedPhoneNumber = `${form.phoneCountryCode}${form.phoneNumber}`.replace(/\s+/g, "");


        const payload = {
            ...form,
            phoneNumber: normalizedPhoneNumber,
            ports: selectedPorts,
            reports: selectedReportTypes,
            ...(newPassword ? { password: newPassword } : {})
        };

        delete payload.phoneCountryCode;
        delete payload.username;



        if (payload.role !== 'BOARDING_OPERATOR') {
            delete payload.ports;

        }
        let progressInterval;

        try {
            // Smooth progress animation
            progressInterval = setInterval(() => {
                setSaveProgress((prev) => Math.min(prev + 10, 90));
            }, 300);

            const instance = UserClass.getInstance();
            const token = instance.getTokenUser();

            const { data, msgError } = await DataManager.updateUser(token, id, payload);

            clearInterval(progressInterval);

            if (msgError) {
                setUpdateError(msgError);
                setSaveProgress(100);
                setTimeout(() => {
                    setShowModal(false)
                }, 2500)
                return;
            }

            // Success
            setSaveProgress(100);

            setTimeout(() => {
                setShowModal(false);
                setShowSuccessToast(true);
            }, 300);

            setTimeout(() => {
                window.location.href = "/pages/UserManagement/";
            }, 2500);

        } catch (err) {
            clearInterval(progressInterval);
            console.error(err);
            setUpdateError(t("user_creation_failed"));
            setSaveProgress(100);
        } finally {
            setIsSaving(false);
        }
    };

    const copyToClipboard = (text) => {
        navigator?.clipboard?.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const updatePassword = () => {

        //console.log("newPassword: ",newPassword);
        setShowModal(true);
        handleConfirm();
        setShowResetModal(false);
    }

    const getRoles = async () => {

        setIsLoadingRoles(true);
        setRolesError(null);

        try {
            const instance = UserClass.getInstance();
            const token = instance.getTokenUser();

            const { data, msgError } = await DataManager.getRoles(token);



            if (msgError) {
                throw new Error(msgError);
            }

            setRoles(data);
        } catch (error) {
            setRoles([]);
            setRolesError(error.message || t("msgErrorGeneral"));
        } finally {
            setIsLoadingRoles(false);
        }

    }


    const toggleDefaultSending = (id) => {
        setSelectedReportTypes((prev) =>
            prev.map((r) =>
                r.id === id
                    ? { ...r, defaultSending: !r.defaultSending }
                    : r
            )
        );
    };

    const toggleAppearInSendingList = (id) => {
        setSelectedReportTypes((prev) =>
            prev.map((r) =>
                r.id === id
                    ? { ...r, appearInSendingList: !r.appearInSendingList }
                    : r
            )
        );
    }


    return (
        <>
            <div className={styles.CreateUser}>
                <Container fluid="md">
                    {/* Header */}
                    <Row className="mb-4 align-items-center">
                        <Col>
                            <h2 className={styles.title}>{t("edit_user")}</h2>
                            <div className={styles.subtitle}>{t("edit_user_description")}</div>
                        </Col>
                        <Col xs="auto">
                            <Button variant="secondary" className="me-2" onClick={() => setShowModalCancel(true)}
                            >
                                {t("cancel")}
                            </Button>
                            <Button variant="primary" onClick={handleSubmit}>
                                {t("update")}
                            </Button>
                        </Col>
                    </Row>



                    <Tab.Container defaultActiveKey="profile" onSelect={(k) => setActiveTab(k)}>
                        {/* Tabs */}
                        <UserTabs activeKey="profile" showSecurity={true} showPermissions={form.role === "BOARDING_OPERATOR"} />
                        {/* Tab Content */}
                        <Tab.Content>
                            {errors?.ports && (
                                <div className="alert alert-warning py-2">
                                    {activeTab !== "permissions" ? t('set_at_least_one_port_required_in_permissions') : errors.ports}
                                </div>
                            )}
                            {/* PROFILE TAB */}
                            <Tab.Pane eventKey="profile">
                                <UserForm
                                    form={form}
                                    errors={errors}
                                    roles={roles}
                                    companies={companies}
                                    onChange={handleChange}
                                    onSubmit={handleSubmit}
                                    isEdit={true}
                                />
                            </Tab.Pane>

                            <ReportPreferenceTabContent
                                reportTypes={reportTypes}
                                onChange={handleChange}
                                form={form}
                                selectedReportTypes={selectedReportTypes}
                                isEdit={true}
                                toggleReportType={toggleReportType}
                                toggleDefaultSending={toggleDefaultSending}
                                toggleAppearInSendingList={toggleAppearInSendingList}
                                errors={errors}
                            />
                            <SecurityTabContent setShowResetModal={setShowResetModal} setNewPassword={setNewPassword} setShowConfirmReset={setShowConfirmReset} />
                            {
                                form?.role === "BOARDING_OPERATOR" && (
                                    <PermissionsTabContent
                                        ports={ports}
                                        selectedPorts={selectedPorts}
                                        togglePort={togglePort}
                                        errors={errors}

                                    />
                                )
                            }
                        </Tab.Content>
                    </Tab.Container>
                    {/* Modal */}

                    {
                        activeTab === "security" && (<><Modal
                            show={showResetModal}
                            onHide={() => setShowResetModal(false)}
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>{t("password_reset")}</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <p className="text-muted mb-3">
                                    {t("password_reset_admin_info")}
                                </p>

                                <InputGroup className="mb-3">
                                    <Form.Control
                                        value={newPassword}
                                        readOnly
                                        style={{ fontWeight: "bold", letterSpacing: "1px" }}
                                    />
                                    <Button
                                        variant="outline-secondary"
                                        onClick={() => copyToClipboard(newPassword)}
                                    >
                                        {t("copy")}
                                    </Button>
                                </InputGroup>
                                {copied && (
                                    <small className="text-success d-block mt-1">
                                        ✓ {t("copied_to_clipboard")}
                                    </small>
                                )}

                                <div className="alert alert-warning py-2">
                                    ⚠️ {t("password_only_shown_once")}
                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button
                                    variant="primary"
                                    onClick={() => updatePassword()}
                                >
                                    {t("done")}
                                </Button>
                            </Modal.Footer>
                        </Modal>

                            <Modal
                                show={showConfirmReset}
                                onHide={() => setShowConfirmReset(false)}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>{t("confirm_password_reset")}</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <p className="mb-2">
                                        {t("password_reset_warning")}
                                    </p>

                                    <p className="text-danger mb-0">
                                        ⚠️ {t("password_reset_irreversible")}
                                    </p>
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={() => setShowConfirmReset(false)}
                                    >
                                        {t("cancel")}
                                    </Button>

                                    <Button
                                        variant="warning"
                                        onClick={() => {
                                            setShowConfirmReset(false);

                                            const pwd = Functions.generatePassword();
                                            setNewPassword(pwd);
                                            setShowResetModal(true);
                                        }}
                                    >
                                        {t("confirm_reset")}
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </>
                        )
                    }
                    <Modal
                        show={showModal}
                        backdrop="static"
                        keyboard={false}
                        centered
                        dialogClassName={styles.loadingModal}
                    >
                        <Modal.Body className="py-4 text-center">
                            <div className="progress mb-3" style={{ height: "6px" }}>
                                <div
                                    className={`progress-bar progress-bar-striped progress-bar-animated ${updateError ? "bg-danger" : ""
                                        }`}
                                    style={{ width: `${saveProgress}%` }}
                                />
                            </div>

                            <small className="text-muted d-block">
                                {updateError ? t("updating_failed") : t("updating_user")}
                            </small>


                            {updateError && (
                                <div className="alert alert-danger py-2 mt-3">
                                    {updateError}
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>

                    {/* Cancel Confirmation Modal */}
                    <Modal
                        show={showModalCancel}
                        onHide={() => !isSaving && setShowModalCancel(false)}
                        backdrop={isSaving ? "static" : true}
                        keyboard={!isSaving}
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{t("cancel_user_update")}</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <p className="mb-2">
                                {t("are_you_sure_you_want_to_cancel")}
                            </p>

                            <p className="text-danger mb-0">
                                ⚠️ {t("all_changes_will_be_discarded")}
                            </p>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={() => setShowModalCancel(false)}
                                disabled={isSaving}
                            >
                                {t("go_back")}
                            </Button>

                            <Button
                                variant="danger"
                                onClick={handleCancelUpdate}
                                disabled={isSaving}
                            >
                                {t("yes_cancel")}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </div>
            <ToastContainer
                position="top-center"
                className="p-3"
                style={{ position: "fixed", marginTop: "70px", zIndex: 2000 }}
            >
                <Toast
                    show={showSuccessToast}
                    bg="success"
                    delay={3000}
                    autohide
                    onClose={() => setShowSuccessToast(false)}
                >
                    <Toast.Header closeButton={false}>
                        <strong className="me-auto">{t("success")}</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">
                        {t("user_updated_successfully")}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    );
};

export default EditUser;
